import React from 'react';

const UnderConstruction = () => (
  <div className='d-flex w-100 align-items-center' style={{ flex: 1 }}>
    <div className='under-construction'></div>
  </div>
);

export default UnderConstruction;